var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: _vm.title, visible: _vm.dialogVisible, width: "40%" },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      !_vm.isAddSuccess
        ? _c(
            "temlate",
            [
              _c(
                "el-form",
                {
                  ref: "appForm",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "170px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { prop: "name", label: this.$t("developer.name") }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          autocomplete: "off",
                          placeholder: this.$t("developer.appNamePla")
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("developer.des"), prop: "des" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: this.$t("developer.desPla")
                        },
                        model: {
                          value: _vm.form.des,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "des",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.des"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : [
            _c(
              "div",
              [
                _c("p", [_vm._v(_vm._s(_vm.$t("developer.createAppSucess")))]),
                _vm._v(" "),
                _c("ZkKvLine", { attrs: { label: "AppKey" } }, [
                  _vm._v(_vm._s(_vm.appDetailInfo.appKey))
                ]),
                _vm._v(" "),
                _c("ZkKvLine", { attrs: { label: "AppSecret" } }, [
                  _vm._v(_vm._s(_vm.appDetailInfo.appSecret))
                ]),
                _vm._v(" "),
                _c("ZkKvLine", { attrs: { label: "EndPoint" } }, [
                  _vm._v(_vm._s(_vm.endPoint))
                ])
              ],
              1
            )
          ],
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.isAddSuccess
                    ? _vm.$t("developer.isOk")
                    : _vm.$t("common.cancel")
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.submitAddOrUpdate }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.isAddSuccess
                      ? _vm.$t("developer.enterApp")
                      : _vm.$t("common.confirm")
                  ) +
                  "\n    "
              )
            ]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c637a6d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c637a6d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/developer/appSetting/appInfo.vue
// module id = null
// module chunks = 